import React, { useCallback, useMemo, useState } from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import AppGeoAnalytics from './AppGeoAnalytics'
import AppCountrySignups from '../appCountrySignups/AppCountrySignups'
import OnboardingCountryFilterEditor from '../onboardingFunnel/OnboardingCountryFilterEditor'
import {
    DEFAULT_COUNTRY_METRICS_COUNTRIES,
    readCountryMetricsPreferences,
    saveCountryMetricsPreferences,
} from './countryMetricsPreferences'
import { ADMIN_ACCESS_MODES } from '../../utils/sessionUtils'

const COUNTRY_FILTER_DESCRIPTION = '지표에 표시할 국가를 선택하세요. DAU/MAU와 회원가입수에 함께 적용되며, 선택한 목록은 이 브라우저에 저장됩니다.'

export default function AppCountryMetrics({ adminId, role, accessMode }) {
    // 두 지표가 같은 국가를 보도록 부모가 들고 있는다. 따로 관리하면 운영자가
    // 한쪽만 바꾼 채로 두 그래프를 나란히 비교하게 된다.
    const [countries, setCountries] = useState(readCountryMetricsPreferences)

    const handleSaveCountries = useCallback((nextCountries) => {
        // 전부 지우면 서버가 기본 목록으로 되돌린다. 화면도 같은 기준을 쓴다.
        const resolved = nextCountries.length > 0
            ? [...new Set(nextCountries)]
            : [...DEFAULT_COUNTRY_METRICS_COUNTRIES]

        setCountries(resolved)
        saveCountryMetricsPreferences(resolved)
    }, [])

    // 두 섹션 헤더에 같은 편집기를 놓는다. 어느 쪽에서 눌러도 결과는 같다.
    const countryFilterSlot = useMemo(() => (
        <OnboardingCountryFilterEditor
            countries={countries}
            onSave={handleSaveCountries}
            defaultCountries={DEFAULT_COUNTRY_METRICS_COUNTRIES}
            description={COUNTRY_FILTER_DESCRIPTION}
        />
    ), [countries, handleSaveCountries])

    if (role <= 3 && accessMode !== ADMIN_ACCESS_MODES.COUNTRY_ANALYTICS_ONLY) {
        return null
    }

    return (
        <>
            <Grid item xs={12}>
                <Typography variant="h5" component="h1" sx={{ fontWeight: 700 }}>국가별 지표</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                    국가별 앱 DAU/MAU와 회원가입수를 확인하세요. 표시 국가와 각 지표의 조회 기간을 개별 설정할 수 있습니다.
                </Typography>
            </Grid>
            <AppGeoAnalytics
                adminId={adminId}
                role={role}
                accessMode={accessMode}
                countries={countries}
                countryFilterSlot={countryFilterSlot}
            />
            <AppCountrySignups
                adminId={adminId}
                role={role}
                accessMode={accessMode}
                countries={countries}
                countryFilterSlot={countryFilterSlot}
            />
        </>
    )
}
